<script>
export default {
  name: "strock-tik-icon",
  props: ["strokeColor"]
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
  >
    <path
      d="M12 2L5.125 11L2 6.909"
      :stroke="strokeColor ? strokeColor : '#00B947'"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
